import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import packages from "../data/packages";
import styles from "./PackageDetails.module.css";

function PackageDetails() {
  const { packageId } = useParams();
  const { addToCart } = useCart();
  const pkg = packages.find((p) => p.id === packageId);

  if (!pkg) {
    return <Navigate to="/" replace />;
  }

  const handleAddToCart = () => {
    addToCart({
      id: pkg.id,
      name: pkg.name,
      price: pkg.price,
      type: "package",
    });
  };

  return (
    <div className={styles.page}>
      <div
        className={styles.banner}
        style={{ backgroundImage: `url(${pkg.image})` }}
      >
        <div className={styles.bannerOverlay}>
          <Link to="/" className={styles.backLink}>
            &larr; Back to packages
          </Link>
          <h1 className={styles.title}>{pkg.name}</h1>
          <p className={styles.price}>AED {pkg.price} / person</p>
        </div>
      </div>

      <div className="container">
        <div className="row g-4">
          <div className="col-12 col-md-7">
            <p className={styles.tagline}>{pkg.tagline}</p>

            <h2 className={styles.sectionHeading}>What's Included</h2>
            <ul className={styles.featureList}>
              {pkg.features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>

            <h2 className={styles.sectionHeading}>Trip Details</h2>
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Duration</span>
              <span>{pkg.duration}</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.detailLabel}>Available Time Slots</span>
              <span>{pkg.timeSlots.join(", ")}</span>
            </div>
          </div>

          <div className="col-12 col-md-5">
            <div className={styles.bookCard}>
              <p className={styles.bookCardPrice}>
                AED {pkg.price}
                <span className={styles.perPerson}>/ person</span>
              </p>
              <button
                type="button"
                className={styles.addToCartBtn}
                onClick={handleAddToCart}
              >
                Add to Cart
              </button>
              <a href="#booking-form" className={styles.bookNowBtn}>
                Book Now
              </a>
              <p className={styles.note}>
                Free cancellation up to 24 hours before your trip.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PackageDetails;
